<div class="load" *ngIf="this.jobLoaded">
    <app-navbar appHideBreadcrumb>
        <h2>Aplica la {{job.jobTitle}}</h2>
    </app-navbar>

    <div class="job-details-area pt-100">
        <div class="container">
            <div class="row">
                <div class="col-lg-8">
                    <div class="job-details-item">
                        <div class="job-image-container">
                            <div class="job-questions" *ngIf="!userAlreadyApplied">
                                <div class="apply-job-container">
                                    <form [useLoader]="isLoading" (ngSubmit)="onSubmit(interviewForm)"
                                          #interviewForm="ngForm">
                                        <div class="row">
                                            <h4 *ngIf="job.miniInterview.question1 !== ''">Pentru a finaliza aplicatia ta la acest job compania angajatoare doreste sa te cunoasca mai bine, asa ca te invita sa raspunzi la urmatoarele intrebari:</h4>
                                            <div class="col-md-12 pt-10" *ngIf="job.miniInterview.question1 !== ''">
                                                <label>{{job.miniInterview.question1}}</label>
                                                <input type="text" id="answer1" class="form-control" ngModel
                                                       name="answer1"
                                                       #answer1="ngModel" required>
                                                <div class="error-msg" *ngIf="!answer1.valid && (answer1.touched || interviewForm.submitted)">
                                                    {{'VALIDATION.REQUIRED' | translate}}
                                                </div>
                                            </div>
                                            <div class="col-md-12" *ngIf="job.miniInterview.question2 !== ''">
                                                <label>{{job.miniInterview.question2}}</label>
                                                <input type="text" id="answer2" class="form-control" ngModel
                                                       name="answer2"
                                                       #answer2="ngModel" required>
                                                <div class="error-msg" *ngIf="!answer2.valid && (answer2.touched || interviewForm.submitted)">
                                                    {{'VALIDATION.REQUIRED' | translate}}
                                                </div>
                                            </div>
                                            <div class="col-md-12" *ngIf="job.miniInterview.question3 !== ''">
                                                <label>{{job.miniInterview.question3}}</label>
                                                <input type="text" id="answer3" class="form-control" ngModel
                                                       name="answer3"
                                                       #answer3="ngModel" required>
                                                <div class="error-msg" *ngIf="!answer3.valid && (answer3.touched || interviewForm.submitted)">
                                                    {{'VALIDATION.REQUIRED' | translate}}
                                                </div>
                                            </div>
                                            <div class="col-md-12" *ngIf="job.miniInterview.question4 !== ''">
                                                <label>{{job.miniInterview.question4}}</label>
                                                <input type="text" id="answer4" class="form-control" ngModel
                                                       name="answer4"
                                                       #answer4="ngModel" required>
                                                <div class="error-msg" *ngIf="!answer4.valid && (answer4.touched || interviewForm.submitted)">
                                                    {{'VALIDATION.REQUIRED' | translate}}
                                                </div>
                                            </div>
                                            <div class="col-md-12" *ngIf="job.miniInterview.question5 !== ''">
                                                <label>{{job.miniInterview.question5}}</label>
                                                <input type="text" id="answer5" class="form-control" ngModel
                                                       name="answer5"
                                                       #answer5="ngModel" required>
                                                <div class="error-msg" *ngIf="!answer5.valid && (answer5.touched || interviewForm.submitted)">
                                                    {{'VALIDATION.REQUIRED' | translate}}
                                                </div>
                                            </div>
                                            <div class="col-md-12 pt-20">
                                                <h4>Aplicatia ta</h4>
                                            </div>

                                            <div class="col-md-12">
                                                <label for="applicationMessage">Lasă un mesaj companiei</label>
                                                <textarea class="form-control" id="applicationMessage"
                                                          name="applicationMessage" #applicationMessage
                                                          ngModel></textarea>
                                            </div>

                                            <div class="col-md-12 pt-20">
                                                <label>Incarca scrisoare recomandare</label>
                                                <input type="file" class="form-control"
                                                       (change)="selectLetter($event)"/>
                                            </div>
                                        </div>
                                        <div class="apply-button-container">
                                            <button type="submit"
                                                    class="apply-button round-button green-background form-control"
                                                    >
                                                    
                                                Aplica
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                           <!-- <app-form-response [serverResponse]='userAlreadyApplied' *ngIf="userAlreadyApplied">
                               <div class="success-content" *ngIf="userAlreadyApplied">
                                   <p class="text-white font-weight-bold mb-0">Ai aplicat pentru acest job, asteapta un
                                       raspuns de la un angajator.</p>
                                   <p class="text-white font-weight-bold mb-0">Urmeaza sa fii redirecitionat in cateva
                                       secunde...</p>
                               </div>
                           </app-form-response> -->
                            <app-form-message [success]="formResponse" *ngIf="formSent" [customSuccessMessage]="customSuccessMessage">

                            </app-form-message>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4">
                    <!-- <h4>Rezumat job</h4> -->
                    <div class="job-details-item">
                        <div class="job-overview job-specs">

                        <ul>
                            <li>
                                <i class="icofont-building"></i>
                                <p>Compania: </p>
                                <span>{{job["companyName"]}}</span>
                            </li>

                            <li>
                                <i class="icofont-location-pin"></i>
                                <p>Locatie job</p>
                                <span>{{job["city"]}}, {{job["country"]}}</span>
                            </li>
                            <li>
                                <i class="icofont-label"></i>
                                <p>Industrie</p>
                                <span>{{job.activitySector}}, {{job.activitySubSector}}</span>
                            </li>
                            <li>

                                <i class="icofont-label"></i>
                                <p>Departament</p>
                                <span>{{job.department}}</span>
                            </li>

                            <li>
                                <i class="icofont-briefcase"></i>
                                <p>Nivel Cariera</p>
                                <span>{{job.experienceLevel | enumTransform}}</span>
                            </li>
                            <li>
                                <i class="icofont-briefcase"></i>
                                <p>Tip job:</p>
                                <span>{{job.workType  | enumTransform}}</span>
                            </li>
                            <li>
                                <i class="icofont-university"></i>
                                <p>Nivel Studii necesare</p>
                                <span>{{job.studies | enumTransform}}</span>
                            </li>
                            <li *ngIf="job['minimumSalary'] > 0 || job['maximumSalary'] > 0">
                                <i class="icofont-money"></i>
                                <p>Salariu oferit:</p>
                                <p *ngIf="job['minimumSalary'] > 0">Minim: {{job["minimumSalary"]}}</p>
                                <p *ngIf="job['maximumSalary'] > 0">Maxim: {{job["maximumSalary"]}}</p>
                            </li>
                            <li>
                                <i class="icofont-clock-time"></i>
                                <p>Valabil până la: </p>
                                <span>{{job["jobEndingDate"] | date:"dd-MM-yyyy"}}</span>
                            </li>

                        </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>
